import { createSelector } from '@reduxjs/toolkit';
import { StoreData } from 'store/root-reducer';

const selectMyShopPageData = (state: StoreData) => state.myShopPageData;

const selectDeletedProductIds = createSelector(selectMyShopPageData, (data) => data.deletedProductIds);

export const selectAvailableProducts = createSelector([selectMyShopPageData, selectDeletedProductIds], (data, deletedIds) => {
  const deletedSet = new Set(deletedIds);

  return data.availableProducts.filter((p) => !deletedSet.has(String(p.id)));
});

export const selectOtherStatusesProducts = createSelector([selectMyShopPageData, selectDeletedProductIds], (data, deletedIds) => {
  const deletedSet = new Set(deletedIds);

  return data.otherStatusesProducts.filter((p) => !deletedSet.has(String(p.id)));
});

export const selectAvailableTotal = createSelector(selectMyShopPageData, (data) => {
  const { availableTotal, deletedProductIds } = data;

  return availableTotal !== null ? Math.max(0, availableTotal - deletedProductIds.length) : null;
});

export const selectOtherTotal = createSelector(selectMyShopPageData, (data) => data.otherTotal);
